module.exports = __webpack_public_path__ + "static/img/lifestyle_10.b56be66c.jpg";